// Resolves a Paths plan link's ?topic=<topic paper id> (built by backend
// capability_targets.build_launch_url, e.g. /practice/ucat?topic=UCAT-T0001)
// against the exam's topic papers the practice page loaded.
//
// Returns one of:
//   { status: 'absent' }                         no ?topic= on the URL
//   { status: 'pending' }                        topic papers not loaded yet: say nothing
//   { status: 'found', ref, label, paper }       exactly that topic paper exists
//   { status: 'not_found', echo }                loaded, and no topic paper has that id
//   { status: 'invalid', echo }                  blank or not plain text
//
// Only an exact paper id match counts. There is no fuzzy or prefix fallback, so a plan
// link can never open a different paper. An old topic code (UCAT1.1) is not a paper id:
// it is not found, and the plan-topic bar says so.
export function resolvePlanTopic(planTopic, topicPapers, loaded) {
  if (!planTopic || planTopic.status === 'absent') return { status: 'absent' };
  if (planTopic.status === 'invalid') return { status: 'invalid', echo: planTopic.echo };
  if (!loaded) return { status: 'pending' };
  const match = (topicPapers || []).find((p) => String(p?.paper_id || '') === planTopic.value);
  if (!match) return { status: 'not_found', echo: planTopic.echo };
  return {
    status: 'found',
    ref: match.paper_id,
    label: match.title || match.paper_id,
    paper: match,
  };
}
